import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "header_wrapper" }
const _hoisted_3 = { class: "body-2 blue-grey--text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_toolbar = _resolveComponent("v-toolbar")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_form = _resolveComponent("v-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_v_toolbar, {
        color: "primary",
        class: "position-relative"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_btn, {
            onClick: _ctx.routerBack,
            icon: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, null, {
                default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                  _createTextVNode("mdi-chevron-left", -1)
                ]))]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_v_toolbar_title, {
            class: "text-center",
            style: {"position":"absolute","left":"0","right":"0","width":"100%","margin-left":"0","pointer-events":"none"}
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t('familyEdit.title')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_v_spacer),
          _createVNode(_component_v_btn, {
            onClick: _ctx.putFamilyById,
            loading: _ctx.btnLoading,
            variant: "text",
            class: "font-weight-bold mr-2"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t('familyEdit.save')), 1)
            ]),
            _: 1
          }, 8, ["onClick", "loading"])
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_v_form, {
      ref: "put_me_form",
      class: "content_wrapper px-2 py-3"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.t('familyEdit.familyName')), 1),
          _createVNode(_component_v_text_field, {
            modelValue: _ctx.familyName,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.familyName) = $event)),
            rules: [_ctx.rules.required],
            outlined: "",
            dense: ""
          }, null, 8, ["modelValue", "rules"])
        ])
      ]),
      _: 1
    }, 512)
  ]))
}